<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import TextField from '@/components/input/TextField.vue'
import { UploadQuery } from '@/generated/graphql'

const { t } = useI18n()

// Two-way binding with parent via v-model
const searchQuery = defineModel<UploadQuery>({ required: true })
</script>

<template>
  <v-card style="height: 100%">
    <v-card-text>
      <text-field
        v-model="searchQuery.nameContains"
        :label="t('component.uploadPicker.search')"
        clearable
      />
    </v-card-text>
  </v-card>
</template>

<style scoped lang="scss"></style>
